export class ProminenceByReachRequestModel  {
    prominenceGroupId: number;
    prominenceThreshold?: number;
    reachThreshold?: number;

    constructor(prominenceGroupId: number, prominenceThreshold?: number, reachThreshold?: number) {
        this.prominenceGroupId = prominenceGroupId;
        this.prominenceThreshold = prominenceThreshold ? prominenceThreshold : 0.69;
        this.reachThreshold = reachThreshold ? reachThreshold : 150000;
    }
}
